<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconEdit_16"
>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2.985c-.58 0-1.135.23-1.545.64l-8.75 8.75a.7.7 0 0 0-.184.326l-.7 2.8a.7.7 0 0 0 .849.848l2.8-.7a.7.7 0 0 0 .325-.184l8.75-8.75A2.185 2.185 0 0 0 12.2.985ZM7.3 13.67a.7.7 0 0 1 .7-.7h6.3a.7.7 0 1 1 0 1.4H8a.7.7 0 0 1-.7-.7Z"
        fill="currentColor"
    />
</svg>
